import html2canvas from "html2canvas";

export const RETOUCH_POSTER_WIDTH = 414;
export const RETOUCH_POSTER_HEIGHT = Math.round((RETOUCH_POSTER_WIDTH * 16) / 9);

function sanitizeFilename(name) {
    return String(name || "retouch-review")
        .trim()
        .replace(/[^\w\u4e00-\u9fff\- ]+/g, "")
        .replace(/\s+/g, "-")
        .slice(0, 60) || "retouch-review";
}

export function formatRetouchPosterExpiry(expiry) {
    const value = Number(expiry);
    const date = Number.isFinite(value) && value > 0 ? new Date(value * 1000) : new Date(expiry);
    if (Number.isNaN(date.getTime())) return "—";
    const pad = (part) => String(part).padStart(2, "0");
    return `${date.getFullYear()}.${pad(date.getMonth() + 1)}.${pad(date.getDate())}`;
}

export async function ensureRetouchReviewPosterReady() {
    if (document.fonts?.ready) await document.fonts.ready;
}

export async function downloadRetouchReviewPosterFromElement(element, albumName) {
    if (!element) throw new Error("Poster element is missing");
    await ensureRetouchReviewPosterReady();
    const canvas = await html2canvas(element, {
        scale: 2,
        backgroundColor: "#fbfbfd",
        logging: false,
        useCORS: true,
        width: RETOUCH_POSTER_WIDTH,
        height: RETOUCH_POSTER_HEIGHT,
    });
    const link = document.createElement("a");
    link.download = `${sanitizeFilename(albumName)}-retouch-review-poster.png`;
    link.href = canvas.toDataURL("image/png");
    link.click();
}
